export default "__VITE_ASSET__GNAQjKt1__"